import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout/index.vue'

Vue.use(Router)

const pageRoutes = [
  { path: 'dashboard', component: () => import('@/views/dashboard/index.vue'), meta: { title: '工作台' } },
  {
    path: 'messages',
    component: () => import('@/views/messages/list.vue'),
    meta: {
      title: '消息通知',
      menuPath: '/dashboard',
      noTag: true,
      breadcrumb: [
        { title: '工作台', path: '/dashboard' },
        { title: '消息通知' }
      ]
    }
  },
  {
    path: 'wallet',
    component: () => import('@/views/wallet/index.vue'),
    meta: {
      title: '账户中心',
      menuPath: '/dashboard',
      noTag: true,
      breadcrumb: [
        { title: '工作台', path: '/dashboard' },
        { title: '账户中心' }
      ]
    }
  },
  {
    path: 'profile',
    component: () => import('@/views/profile/index.vue'),
    meta: { title: '机构资料', menuPath: '/profile' }
  },
  {
    path: 'profile/edit',
    component: () => import('@/views/profile/edit.vue'),
    meta: {
      title: '修改资料',
      menuPath: '/profile',
      breadcrumb: [
        { title: '机构资料', path: '/profile' },
        { title: '修改资料' }
      ]
    }
  },
  { path: 'course', component: () => import('@/views/course/list.vue'), meta: { title: '课程管理' } },
  {
    path: 'course/detail',
    component: () => import('@/views/course/detail.vue'),
    meta: {
      title: '课程详情',
      menuPath: '/course',
      breadcrumb: [
        { title: '课程管理', path: '/course' },
        { title: '课程详情' }
      ]
    }
  },
  {
    path: 'course/edit',
    component: () => import('@/views/course/edit.vue'),
    meta: {
      title: '编辑课程',
      menuPath: '/course',
      breadcrumb: [
        { title: '课程管理', path: '/course' },
        { title: '编辑课程' }
      ]
    }
  },
  { path: 'course-select', redirect: '/activity/assemble', meta: { title: '生成方案' } },
  { path: 'course-audit', redirect: () => ({ path: '/audit', query: { tab: 'course' } }), meta: { title: '课程审核' } },
  { path: 'select', component: () => import('@/views/activity/select.vue'), meta: { title: '选课接单' } },
  { path: 'activity', component: () => import('@/views/activity/list.vue'), meta: { title: '订单 / 方案' } },
  {
    path: 'activity/detail',
    component: () => import('@/views/activity/detail.vue'),
    meta: {
      title: '详情',
      menuPaths: ['/activity', '/edu/activity', '/edu/study-activity'],
      breadcrumb: [
        { title: '列表', path: '/activity' },
        { title: '详情' }
      ]
    }
  },
  {
    path: 'activity/assemble',
    component: () => import('@/views/activity/assemble.vue'),
    meta: {
      title: '生成方案',
      menuPath: '/activity',
      breadcrumb: [
        { title: '活动方案', path: '/activity' },
        { title: '编辑方案' }
      ]
    }
  },
  { path: 'activity-audit', redirect: () => ({ path: '/audit', query: { tab: 'activity' } }), meta: { title: '方案审核' } },
  {
    path: 'audit',
    component: () => import('@/views/edu/audit.vue'),
    meta: { title: '审核' }
  },
  {
    path: 'edu/course',
    component: () => import('@/views/edu/course.vue'),
    meta: { title: '课程' }
  },
  {
    path: 'edu/activity',
    redirect: '/edu/study-activity'
  },
  {
    path: 'edu/study-activity',
    component: () => import('@/views/edu/activity.vue'),
    meta: { title: '研学活动' }
  },
  { path: 'enroll', component: () => import('@/views/enroll/list.vue'), meta: { title: '报名记录' } },
  { path: 'org-audit', component: () => import('@/views/org/audit.vue'), meta: { title: '审核' } },
  {
    path: 'org-audit/detail',
    component: () => import('@/views/org/audit-detail.vue'),
    meta: {
      title: '入驻申请详情',
      menuPath: '/org-audit',
      breadcrumb: [
        { title: '审核', path: '/org-audit' },
        { title: '申请详情' }
      ]
    }
  },
  { path: 'org-list', component: () => import('@/views/org/list.vue'), meta: { title: '机构信息' } },
  {
    path: 'org-list/detail',
    component: () => import('@/views/org/audit-detail.vue'),
    meta: {
      title: '机构详情',
      menuPath: '/org-list',
      breadcrumb: [
        { title: '机构信息', path: '/org-list' },
        { title: '机构详情' }
      ]
    }
  },
  { path: 'evaluation', component: () => import('@/views/evaluation/index.vue'), meta: { title: '评价', menuPath: '/activity' } },
  { path: 'camera', component: () => import('@/views/camera/index.vue'), meta: { title: '摄像头监控', darkLayout: true } },
  { path: 'bureau-eval', component: () => import('@/views/bureau/eval.vue'), meta: { title: '评价监管', menuPath: '/dashboard' } },
  { path: 'statistics', component: () => import('@/views/statistics/index.vue'), meta: { title: '数据中心' } },
  { path: 'bureau-notice', redirect: '/tools/notice' },
  {
    path: 'tools',
    component: () => import('@/views/tools/layout.vue'),
    redirect: '/tools/notice',
    meta: { title: '工具' },
    children: [
      {
        path: 'notice',
        component: () => import('@/views/bureau/notice.vue'),
        meta: { title: '通知', menuPath: '/tools' }
      }
    ]
  },
  {
    path: 'settings',
    component: () => import('@/views/settings/layout.vue'),
    redirect: '/settings/security',
    meta: { title: '设置' },
    children: [
      {
        path: 'security',
        component: () => import('@/views/settings/security.vue'),
        meta: { title: '安全中心', menuPath: '/settings' }
      }
    ]
  },
  { path: 'filing', component: () => import('@/views/bureau/filing.vue'), meta: { title: '出行备案' } },
  { path: 'norm', component: () => import('@/views/bureau/norm.vue'), meta: { title: '基地规范' } },
  { path: 'fans', component: () => import('@/views/fans/index.vue'), meta: { title: '我的粉丝' } },
  { path: 'vehicle', component: () => import('@/views/resource/vehicle.vue'), meta: { title: '车辆管理' } },
  { path: 'driver', component: () => import('@/views/resource/driver.vue'), meta: { title: '司机管理' } },
  { path: 'schedule', component: () => import('@/views/resource/schedule.vue'), meta: { title: '时段排班' } },
  { path: 'ops', redirect: '/ops/bookable', meta: { title: '运营设置' } },
  {
    path: 'ops/bookable',
    component: () => import('@/views/ops/bookable.vue'),
    meta: {
      title: '可约设置',
      menuPath: '/ops',
      breadcrumb: [
        { title: '运营设置', path: '/ops' },
        { title: '可约设置' }
      ]
    }
  },
  {
    path: 'ops/course-bookable',
    component: () => import('@/views/ops/course-bookable.vue'),
    meta: { title: '约课日历' }
  },
  {
    path: 'ops/hotel-inventory',
    component: () => import('@/views/ops/hotel-inventory.vue'),
    meta: { title: '房态日历' }
  },
  {
    path: 'ops/restaurant-bookable',
    component: () => import('@/views/ops/restaurant-bookable.vue'),
    meta: { title: '订座日历' }
  },
  { path: 'room', component: () => import('@/views/resource/room.vue'), meta: { title: '房型管理' } },
  { path: 'menu', component: () => import('@/views/resource/menu.vue'), meta: { title: '菜品套餐' } },
  { path: 'news', component: () => import('@/views/news/list.vue'), meta: { title: '新闻资讯' } },
  {
    path: 'news/detail',
    component: () => import('@/views/news/detail.vue'),
    meta: {
      title: '资讯详情',
      menuPath: '/news',
      breadcrumb: [
        { title: '新闻资讯', path: '/news' },
        { title: '资讯详情' }
      ]
    }
  }
]

export const constantRoutes = [
  { path: '/login', component: () => import('@/views/login/index.vue'), hidden: true },
  { path: '/register', component: () => import('@/views/register/index.vue'), hidden: true },
  { path: '/pending', component: () => import('@/views/pending/index.vue'), hidden: true, meta: { title: '入驻审核' } },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: pageRoutes
  },
  { path: '*', redirect: '/dashboard', hidden: true }
]

const router = new Router({
  mode: 'hash',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

export default router
